export const buildUrl = (path: string, params: Record<string, string | number>) => {
  let url = path
  Object.entries(params).forEach(([key, value]) => {
    url = url.replace(`:${key}`, value.toString())
  })
  return url
}
